var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-header"},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{on:{"click":_vm.closeClick}},[_vm._v(" mdi-"+_vm._s(_vm.btnType == "close" ? "close" : "chevron-left")+" ")])],1),_c('h4',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }